<template>
  <div class="bq-product-zsygl">
    <SectionTitle :title="'产品简介'" noSpacing></SectionTitle>
    <div class="container-div">
      <div class="container">
        <div class="left-mark"></div>
        <p>
          主索引管理平台（Enterprise Master Patient
          Index，EMPI）主要实现区域内不同机构、不同信息系统之间的信息交互共享，必须首先解决相同患者在不同机构、不同系统中的身份识别和统一问题。
        </p>
        <p>
          患者主索引是指用特定的算法实现医疗机构内患者标识信息的创建、维护，为每个患者或居民提供唯一标识符，实现对患者信息的有效检索。居民在区域内任何卫生机构接受健康服务产生的健康数据将会与个人唯一标识进行统一关联，形成一个完整的健康数据集合。
        </p>
        <div class="right-mark"></div>
      </div>
    </div>
    <div class="area">
      <div class="area-title">
        索引管理平台
      </div>
      <div class="area-content">
        <div class="content-item">
          <div class="manage-content-title">
            平台管理
          </div>
          <div class="manage-content">
            <div class="manage-desc">索引管理</div>
            <div class="manage-desc">权重配置</div>
            <div class="manage-desc">疑似列表</div>
            <div class="manage-desc">日志管理</div>
          </div>
        </div>
        <div class="content-item">
          <div class="manage-content-title">
            基础服务
          </div>
          <div class="manage-content">
            <div class="manage-desc3">索引创建</div>
            <div class="manage-desc3">索引更新</div>
            <div class="manage-desc3">索引检索</div>
            <div class="manage-desc3">索引合并</div>
            <div class="manage-desc3">索引拆分</div>
            <div class="manage-desc3">索引删除</div>
          </div>
        </div>
        <div class="content-item">
          <div class="data-source-title">
            数据来源
          </div>
          <div class="manage-content">
            <img
              class="data-source"
              src="https://img.alicdn.com/tfs/TB19aSnDGL7gK0jSZFBXXXZZpXa-300-188.png"
            />
            <img
              class="data-source"
              src="https://img.alicdn.com/tfs/TB1uzeiDKL2gK0jSZPhXXahvXXa-300-188.png"
            />
            <img
              class="data-source"
              src="https://img.alicdn.com/tfs/TB1IqmnDGL7gK0jSZFBXXXZZpXa-220-188.png"
            />
          </div>
        </div>
      </div>
    </div>
    <SectionTitle :title="'产品优势'" noSpacing></SectionTitle>
    <div
      class="bq-advantage"
      v-for="(itemList, idx) in advantageList"
      :key="idx"
    >
      <InfoBox
        :itemObj="item"
        :col="3"
        v-for="item in itemList"
        :key="item.advTitles"
        :classes="'advantage'"
      ></InfoBox>
    </div>
  </div>
</template>
<script>
import SectionTitle from '@/components/website_v3/SectionTitle';
import InfoBox from '@/components/website_v3/InfoBox';

export default {
  name: 'zsygl',
  data() {
    return {
      advantageList: [
        [
          {
            iconUrl:
              'https://img.alicdn.com/tfs/TB19_iDDRr0gK0jSZFnXXbRRXXa-84-84.png',
            advTitles: '一人一码',
            advDesc:
              '形成区域或医院一人一码，提供个人唯一标识，形成全面完整的档案信息。',
          },
          {
            iconUrl:
              'https://img.alicdn.com/tfs/TB1gqmmDKL2gK0jSZPhXXahvXXa-88-84.png',
            advTitles: '系统互通',
            advDesc:
              '个人索引管理，可以将分散在不同的业务系统数据关联，形成业务系统的互联互通。',
          },
          {
            iconUrl:
              'https://img.alicdn.com/tfs/TB1c4GuDNn1gK0jSZKPXXXvUXXa-80-88.png',
            advTitles: '数据互联',
            advDesc:
              '一人一码，提供业务系统互通、数据互联基础，确保数据完整，统一。',
          },
        ],
      ],
    };
  },
  components: {
    SectionTitle,
    InfoBox,
  },
};
</script>
<style lang="less" scoped>
@import './zsygl.less';
</style>
